import React, { useEffect, useState } from "react";

const WeatherPopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [unit, setUnit] = useState("C");
    const [language, setLanguage] = useState("en");
    const [forecastDays, setForecastDays] = useState(5);
    const [showTemperature, setShowTemperature] = useState(true);
    const [showHumidity, setShowHumidity] = useState(true);
    const [showWind, setShowWind] = useState(true);
    const [showForecast, setShowForecast] = useState(true);
    const [duration, setDuration] = useState(30);


    useEffect(() => {

        if (media) {

            setName(media.name);
            setLocation(media.location || "");
            setApiKey(media.apiKey || "");
            setUnit(media.unit || "C");
            setLanguage(media.language || "en");
            setForecastDays(media.forecastDays || 5);

            setShowTemperature(media.showTemperature ?? true);
            setShowHumidity(media.showHumidity ?? true);
            setShowWind(media.showWind ?? true);
            setShowForecast(media.showForecast ?? true);

            setDuration(media.duration || 30);
        }

    }, [media]);


    const handleSave = () => {

        onSave({

            id: media?.id || null,

            name,

            location,

            apiKey,

            unit,

            language,

            forecastDays,

            showTemperature,

            showHumidity,

            showWind,

            showForecast,

            duration

        });

    };


    return (

        <div className="popup-overlay">

            <div className="popup-content" style={{width:650}}>

                <h2>
                    {media ? "Edit Weather" : "Add Weather"}
                </h2>


                <div className="form-group">
                    <label>Name</label>

                    <input
                        className="form-control"
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                    />

                </div>


                <div className="form-group">

                    <label>Location</label>

                    <input
                        className="form-control"
                        placeholder="London, UK"
                        value={location}
                        onChange={(e)=>setLocation(e.target.value)}
                    />

                </div>


                <div className="form-group">

                    <label>Weather API Key</label>

                    <input
                        className="form-control"
                        value={apiKey}
                        onChange={(e)=>setApiKey(e.target.value)}
                    />

                </div>


                <div className="form-group">

                    <label>Temperature Unit</label>

                    <select
                        className="form-control"
                        value={unit}
                        onChange={(e)=>setUnit(e.target.value)}
                    >
                        <option value="C">Celsius °C</option>
                        <option value="F">Fahrenheit °F</option>
                    </select>

                </div>


                <div className="form-group">

                    <label>Forecast Days</label>

                    <select
                        className="form-control"
                        value={forecastDays}
                        onChange={(e)=>setForecastDays(Number(e.target.value))}
                    >
                        <option value="1">Today</option>
                        <option value="3">3 Days</option>
                        <option value="5">5 Days</option>
                        <option value="7">7 Days</option>
                    </select>

                </div>


                <hr/>


                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showTemperature}
                        onChange={(e)=>setShowTemperature(e.target.checked)}
                    />
                    <label>
                        &nbsp;Temperature
                    </label>
                </div>


                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showHumidity}
                        onChange={(e)=>setShowHumidity(e.target.checked)}
                    />
                    <label>
                        &nbsp;Humidity
                    </label>
                </div>


                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showWind}
                        onChange={(e)=>setShowWind(e.target.checked)}
                    />
                    <label>
                        &nbsp;Wind Speed
                    </label>
                </div>


                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={showForecast}
                        onChange={(e)=>setShowForecast(e.target.checked)}
                    />

                    <label>
                        &nbsp;Show Forecast
                    </label>

                </div>


                <div className="form-group mt-3">

                    <label>
                        Refresh Duration (seconds)
                    </label>

                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e)=>setDuration(Number(e.target.value))}
                    />

                </div>


                <div className="form-buttons">

                    <button
                        className="btn btn-success"
                        onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button
                        className="btn btn-primary"
                        onClick={onClose}>
                        Cancel
                    </button>

                </div>


            </div>

        </div>

    );

};

export default WeatherPopup;